require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-campaign-disability-rights.json") })
        }
      }, "path---en-us-campaign-disability-rights");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-campaign-disability-rights!./.cache/json/en-us-campaign-disability-rights.json
// module id = 470
// module chunks = 231608221292675